<template>
  <Screen>
    <AppBar
      title="Manage vlogs"
      :description="`Add or update vlogs`"
      :showBackButton="false"
    >
      <inertia-link
        :href="$route('admin.vlogs.create')"
        class="btn btn-sm btn-primary"
      >
        <i class="fa fa-plus"></i>
        <span class="d-none d-app-inline">Add new</span>
      </inertia-link>
    </AppBar>
    <Breadcrumbs title="Vlogs" />
    <div class="card">
      <div class="card-body">
        <SearchBar
          @onSubmit="searchSubmit"
          @onClear="searchCleared"
          v-model="searchInput"
        />
        <div class="table-responsive" v-if="data.data.length > 0">
          <table class="table mb-0">
            <thead class="thead-light">
              <tr>
                <th>#</th>
                <th>Thumbnail</th>
                <th>Title</th>
                <th>Seo tags</th>
                <th>Status</th>
                <th>Created</th>
                <th>Updated</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, i) in data.data" :key="item.id">
                <td>
                  {{
                    i + 1 + (data.meta.current_page - 1) * data.meta.per_page
                  }}
                </td>
                <td>
                  <img
                    v-lazy="item.thumbnail"
                    :alt="item.title"
                    class="preview-img-sm"
                    width="100"
                    height="100"
                    style="background-color: #f1f1f1"
                  />
                </td>
                <th style="max-width: 300px">
                  <div class="mb-1">
                    <a href="#">
                      {{ item.title }}
                    </a>
                  </div>
                  <button
                    class="btn btn-primary btn-sm"
                    @click.prevent="previewThis(item)"
                  >
                    Play video
                    <small class="fa fa-play ml-1"></small>
                  </button>
                </th>
                <td>{{ item.seo_tags || "-" }}</td>
                <th>
                  <StatusSwitch
                    :dataid="item.id"
                    :status="item.isactive"
                    action="vlogStatus"
                  />
                </th>
                <td>{{ item.created_at_human || "-" }}</td>
                <td>{{ item.updated_at_human || "-" }}</td>
                <td>
                  <inertia-link
                    class="btn btn-sm btn-light"
                    :href="
                      $route('admin.vlogs.edit', {
                        id: item.id,
                      })
                    "
                  >
                    Update
                  </inertia-link>
                  <button
                    @click.prevent="deleteThis(item.id)"
                    class="btn btn-sm btn-danger"
                  >
                    Delete
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <NoData title="No vlogs added yet" v-else>
          <inertia-link
            :href="$route('admin.vlogs.create')"
            class="btn btn-primary"
          >
            <i class="fa fa-plus"></i> Add new
          </inertia-link>
        </NoData>
        <Pagination :rawData="data.meta" :onClick="pageChange" />
      </div>
    </div>
    <Modal
      :isOpen.sync="previewModal.isOpen"
      id="preview-vlog"
      :title="previewModal.data.title || 'Preview'"
      size="large"
    >
      <div>
        <div v-if="previewModal.loading" class="text-center p-5">
          <div class="spinner-border spinner-border-lg" role="status"></div>
        </div>
        <iframe
          v-if="previewModal.external_url"
          :src="previewModal.external_url"
          frameborder="0"
          class="preview-iframe"
        ></iframe>
        <div class="alert alert-danger" v-if="previewModal.external_url_error">
          Error loading video
        </div>
      </div>
    </Modal>
  </Screen>
</template>
<script>
export default {
  components: {},
  props: {
    data: {
      type: [Array, Object],
      default: () => [],
    },
    search: {
      type: String,
      default: "",
    },
  },
  watch: {
    search: {
      immediate: true,
      handler(value) {
        this.searchInput = value;
      },
    },
  },
  data() {
    return {
      searchInput: "",
      previewModal: {
        isOpen: false,
        data: {},
        loading: true,
        external_url: null,
        external_url_error: false,
      },
    };
  },
  mounted() {},
  methods: {
    async deleteThis(id) {
      this.$root.$emit("confirmModal", {
        title: "Do you want to delete this vlog?",
        message: "You won't be able to revert this!",
        confirmText: "Yes, delete it!",
        onConfirm: () => {
          this.$root.$emit("hold-transition", null);
          this.$inertia.delete(
            this.$route("admin.vlogs.delete", {
              id: id,
            })
          );
        },
      });
    },
    searchSubmit(search) {
      this.$root.$emit("hold-transition", null);
      this.$inertia.visit(
        this.$route(this.$route().current(), {
          search: search,
          page: 1,
        })
      );
    },
    searchCleared() {
      this.$root.$emit("hold-transition", null);
      this.$inertia.visit(
        this.$route(this.$route().current(), {
          search: "",
          page: 1,
        })
      );
    },
    pageChange(page) {
      this.$root.$emit("hold-transition", null);
      this.$inertia.visit(
        this.$route(this.$route().current(), {
          page: page,
          search: this.searchInput,
        })
      );
    },
    previewThis(data) {
      this.previewModal.isOpen = true;
      this.previewModal.data = data;
      this.previewModal.loading = true;
      this.previewModal.external_url = null;
      this.previewModal.external_url_error = false;

      this.$nextTick(() => {
        setTimeout(() => {
          this.previewModal.loading = false;

          if (data.external_url) {
            this.previewModal.external_url = data.external_url;
          } else {
            this.previewModal.external_url_error = true;
          }
        }, 500);
      });
    },
  },
  computed: {},
};
</script>
<style lang="scss" scoped>
.preview-iframe {
  width: 100%;
  height: max(500px, 70vh);
  border: none;
  border-radius: var(--border-radius);
  background-color: var(--lighter);
  box-shadow: var(--box-shadow);
}
</style>
